@if (loaded) {
  <div fxLayout="column" [ngClass]="basketWrapperFloat(basketOpMode)" class="hw-block"
    [ngStyle]="{'padding-bottom':!readonlyMode ? '5em' : '0' }">
    <!--basket items-->
    @if (basketService.isAnyItemInBasket_ByResponse()) {
      <div>
        <div class="basket-container basket-body">
          @for (ticket of basketService.basketResponse.items; track ticket) {
            <div class="hw-block">
              <div fxLayout="row" class="basket-body hw-padding-bottom-05em">
                <div fxFlex="70">
                  <span class="ticket-area-name-span">
                    {{ticket.areaName | uppercase}}
                  </span>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="center center">
                <div fxFlex="100">
                  <span [ngStyle]="ticketName(basketOpMode)"> {{ticket.ticketName }} </span>
                  @for (err of ticket.errors; track err) {
                    <div>
                      <div class="capacity-problem">{{err.message}}</div>
                    </div>
                  }
                  <!--<div class="capacity-problem" *ngIf="ticket.hasError">{{getItemErrorMessage(ticket)}}</div>-->
                  <div class="capacity-problem-div hw-padding-top-05em">
                    <span class="capacity-problem-span"> {{ ticket.date | date:'shortDate':undefined:currLocale}}</span>
                    <span class="price-amount">{{(ticket.unitPrice |number:undefined:currLocale ) + " " + ticket.currency.symbol}}</span>
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutAlign="end center" class="basket-mobile-height">
                <div>
                  <div fxLayout="row" fxLayoutAlign="center center" class="add-circle-buttons">
                    @if (!readonlyMode) {
                      <div fxFlex="33" fxLayoutAlign="start center" class="decrement-container">
                        <button class="accessibility-button" (click)="decrementQuantity(ticket)">
                          <span class="decrement-quantity-span hw-cursor mdi mdi-minus-circle-outline hw-float-right decrement"></span>
                        </button>
                      </div>
                    }
                    <div fxFlex="33" fxLayoutAlign="center center" class="price-amount-container">
                      <span class="price-amount-value">{{ticket.quantity}}</span>
                      @if (readonlyMode) {
                        <span class="price-amount-value">{{ticket.unit}}</span>
                      }
                    </div>
                    @if (!readonlyMode) {
                      <div fxFlex="33" fxLayoutAlign="end center" class="increment-container">
                        <button class="accessibility-button" (click)="incrementQuantity(ticket)">
                          <span class="increment-quantity-span hw-cursor mdi mdi-plus-circle-outline hw-float-left increment"></span>
                        </button>
                      </div>
                    }
                  </div>
                </div>
                @if (!readonlyMode) {
                  <button class="accessibility-button" (click)="removeTicket(ticket)">
                    <span  class="mdi mdi-delete hw-cursor delete-icon" ></span>
                  </button>
                }
                <div [ngStyle]="{'color': ticket.hasError? 'red': 'none'}" class="hw-text-align-right">
                  <div fxFlex="100" fxLayoutAlign="flex-end">
                    <span [ngStyle]="ticketPriceStyle(ticket.hasError)" class="hw-font-size-18px-important">
                      {{ticket.hasError ? translateService.instant("errors.ERR_FEE_CALCULATION") : ((ticket.amount |number:undefined:currLocale) + " " + ticket.currency.symbol) }}
                    </span>
                  </div>
                </div>
              </div>
              <div fxLayout="row">
                <div fxFlex="100" class="hw-padding-top-1em hw-padding-top-2em">
                  <hr class="hw-hr">
                </div>
              </div>
            </div>
          }
        </div>
      </div>
    }
    <!--summary-->
    <div class="hw-block hw-background-color-white hw-custom-total-block">
      <div fxLayout="row">
        <div fxFlex="40" fxFlexAlign="flex-end">
          <span class="sum-span" fxFlexAlign="flex-end"> {{"common.sum" | translate}}:</span>
        </div>
        <div fxFlex="60" fxFlexAlign="flex-end">
          <span [ngStyle]="ticketName(basketOpMode)" class="sub-total-font">
            {{
            basketService.isAnyItemInBasket_ByResponse()
            ? (
            isAnyCalculatableItem()
            ? ((basketService.basketResponse.summary.amount |number:undefined:currLocale ) + " " + basketService.basketResponse.summary.currency.symbol)
            : translateService.instant("errors.ERR_FEE_CALCULATION")
            )
            : "-"
            }}
          </span>
        </div>
      </div>
    </div>
    <!--payment button-->
    <!--<div *ngIf="basketOpMode=='F'" fxLayout="row" fxFlexAlign="center">
    <div style="background-color: white; margin-top: 8px " fxFlex="100" fxFlexAlign="center">
      <button [disabled]="!basketService.isBasketValid()" mat-raised-button
        color="primary" (click)="goToPayment.emit()">
        {{"common.go_to_payment" | translate}}
      </button>
    </div>
  </div>-->
</div>
}